import { UserType } from '@invideoio/web-shared/types/Auth';
import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

export interface UserState {
  userData: UserType | null;
}

// INITIAL TIMER STATE
const initialUserState: UserState = {
  userData: null,
};

// TIMER REDUCER
const userSlice = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {
    LOGIN_USER: (state, action) => {
      return {
        ...state,
        userData: action.payload,
      };
    },
    LOGOUT_USER: state => {
      window.localStorage.clear();
      return {
        ...state,
        userData: null,
      };
    },
  },
});

const userStateSelector = createDraftSafeSelector(
  (state: AppState) => state.user,
  state => state.userData,
);

export { userStateSelector };

export const { LOGIN_USER, LOGOUT_USER } = userSlice.actions;

export default userSlice.reducer;
